import { render, staticRenderFns } from "./input-text-field-simple.vue?vue&type=template&id=64f5b68e&scoped=true"
import script from "./input-text-field-simple.vue?vue&type=script&lang=js"
export * from "./input-text-field-simple.vue?vue&type=script&lang=js"
import style0 from "./input-text-field-simple.vue?vue&type=style&index=0&id=64f5b68e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f5b68e",
  null
  
)

export default component.exports